import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";
import {
    TextField,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import _isEqual from "lodash/isEqual";
import {caseFormChange, resetCaseForm} from '../../../vendors/actions/case';
import {LANGUAGES} from '../../../vendors/utils/common';
import {getCounties, resetCounties, getCourts, resetCourts, getCaseSubTypes, resetCaseSubTypes} from '../../../vendors/actions/static'

import FileUpload from '../fileUpload/index'


interface OwnProps {
    caseFormChange?: any
    getCounties?: any
    resetCounties?: any,
    getCaseSubTypes?: any
    resetCaseSubTypes?: any
    resetCaseForm?: any
    getCourts?: any;
    resetCourts?: any;
}

interface Default {
    id: number
    name: string,
}

interface FormTypes {
    value: Default | {},
    error: string | boolean
}

interface MainState {
    states: Array<Default>,
    counties: Array<Default>,
    caseTypes: Array<Default>,
    caseSubTypes: Array<Default>,
    languages: Array<Default>,
    form: {
        state: FormTypes
        county: FormTypes
        caseType: FormTypes,
        language: FormTypes
        description: {
            value: string,
            error: string | boolean
        }
    }
}

interface ConnectStateProps {
    States: Array<any>,
    CaseTypes: Array<any>,
    Counties: Array<any>,
}

interface ConnectDispatchProps {
    caseFormChange?: (data: any) => void;
    getCounties?: (stateId: number) => void;
    getCaseSubTypes?: (caseTypeId: number) => void;
    resetCounties?: () => void;
    resetCaseSubTypes?: () => void;
    resetCaseForm?: () => void;
    getCourts?: (countyId: number) => void;
    resetCourts?: () => void;

}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;


const TextFieldComponent = (params: any, error: any, label: string, extra?: any) => {
    return (
        <TextField
            {...params}
            error={!!error}
            helperText={error}
            label={label}
            variant="outlined"
            fullWidth
        />
    )
};


const defaultValues = {
    lang: {id: 1, name: "English"} as Default
};


class CaseForm extends React.Component<HeaderProps, MainState> {
    state = {
        states: [],
        caseTypes: [],
        counties: [],
        caseSubTypes: [],
        languages: LANGUAGES,
        form: {
            state: {
                value: {
                    name: ''
                },
                error: false
            },
            county: {
                value: {
                    name: ''
                },
                error: false

            },
            caseType: {
                value: {
                    name: ''
                },
                error: false
            },
            caseSubType: {
                value: {
                    name: ''
                },
                error: false
            },
            language: {
                value: {
                    name: ''
                },
                error: false
            },
            description: {
                value: '',
                error: false
            }
        }
    };

    private countyRef: any = React.createRef<HTMLDivElement>();

    static getDerivedStateFromProps(props: any, state: any) {
        const {States, Counties, CaseTypes, CaseForm, CaseSubTypes} = props;
        if (!_isEqual(state.states, States)) {
            return {
                states: States
            };
        }
        if (!_isEqual(state.caseTypes, CaseTypes)) {
            return {
                caseTypes: CaseTypes
            };
        }
        if (!_isEqual(state.counties, Counties)) {
            return {
                counties: Counties
            };
        }
        if (!_isEqual(state.form, CaseForm.data)) {
            return {
                form: CaseForm.data
            };
        }
        if (!_isEqual(state.caseSubTypes, CaseSubTypes)) {
            return {
                caseSubTypes: CaseSubTypes
            };
        }
        return null;
    }

    componentDidMount() {
        this.selectLanguage(null, defaultValues.lang)
    }

    componentWillUnmount() {
        this.props.resetCaseForm()
    }

    selectState = (e: any, value: any) => {
        this.props.caseFormChange({value, field: 'state'});
        this.props.caseFormChange({value: null, field: 'county'});

        //hack mui autocomplete clear
        const county = this.countyRef.querySelector('.MuiAutocomplete-clearIndicator');
        county && county.click();
        //hack mui autocomplete clear

        this.props.resetCounties();
        if (value) {
            this.props.getCounties(value.id);
        }
    };

    selectCounty = (e: any, value: any) => {
        this.props.caseFormChange({value, field: 'county'})

        this.props.resetCourts();
        if (value) {
            this.props.getCourts(value.id);
        }

    };

    selectCaseType = (e: any, value: any) => {
        this.props.caseFormChange({value, field: 'caseType'});
    };

    selectLanguage = (e: any, value: any) => {
        this.props.caseFormChange({value, field: 'language'})
    };

    addDescription = (e: any) => {
        const value = e.target.value;
        this.props.caseFormChange({value, field: 'description'});
    };

    render() {
        const {states, caseTypes, counties, form, languages} = this.state;
        const mappedCaseTypes = caseTypes.reduce((acc: any, caseType: any) => {
            acc.push(...caseType.subTypes.map((subType: any) => {
                subType.caseTypeName = caseType.name.toUpperCase();
                subType.caseTypeId = caseType.id;
                return subType;
            }));
            return acc;
        }, []);
        return (
            <Fragment>
                <form className="w-100 consumer-style">
                    <div className="text-field-custom-mb">
                        <Autocomplete
                            className='w-100'
                            id="select-state"
                            options={states}
                            onChange={this.selectState}
                            getOptionLabel={(option: any) => option.name}
                            renderInput={params => TextFieldComponent(params, form?.state?.error, 'State')}
                        />
                    </div>

                    <div className="text-field-custom-mb">
                        <Autocomplete
                            id="select-county"
                            options={counties}
                            ref={ref => this.countyRef = ref}
                            onChange={this.selectCounty}
                            getOptionLabel={(option: any) => option.name}
                            renderInput={params => TextFieldComponent(params, form?.county?.error, 'County')}
                        />
                    </div>

                    <div className="text-field-custom-mb">
                        <Autocomplete
                            id="select-case-type"
                            onChange={this.selectCaseType}
                            options={mappedCaseTypes}
                            groupBy={(option: any) => option.caseTypeName}
                            getOptionLabel={(option: any) =>  option.caseTypeName + ', ' + option.name}
                            renderOption={(option: any) => option.name}
                            renderInput={params => TextFieldComponent(
                                params,
                                form?.caseType?.error,
                                'Case Type'
                            )}

                        />
                    </div>

                    <div className="text-field-custom-mb">
                        <Autocomplete
                            id="select-language"
                            onChange={this.selectLanguage}
                            defaultValue={languages.find((l: any) => l.id === defaultValues.lang.id)}
                            options={languages}
                            getOptionLabel={(option: any) => option.name}
                            renderInput={params => TextFieldComponent(params, form?.language?.error, 'Preferred Language')}

                        />
                    </div>

                    <div className="text-field-custom-mb">
                        <TextField
                            value={form?.description?.value || ''}
                            error={!!form?.description?.error}
                            helperText={form?.description?.error}
                            fullWidth
                            onChange={this.addDescription}
                            id="description"
                            label="Description"
                            multiline
                            rows="5"
                            variant="outlined"
                            inputProps={{
                                maxLength: 4000
                            }}
                        />
                    </div>

                    <FileUpload/>

                </form>
            </Fragment>
        )
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {States, CaseTypes, Counties, CaseForm, CaseSubTypes, Languages} = state;
    return {
        States,
        CaseTypes,
        Counties,
        CaseForm,
        CaseSubTypes,
        Languages
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        caseFormChange: (data: any) => dispatch(caseFormChange(data)),
        getCounties: (stateId: number) => dispatch(getCounties(stateId)),
        getCaseSubTypes: (caseTypeId: number) => dispatch(getCaseSubTypes(caseTypeId)),
        resetCounties: () => dispatch(resetCounties()),
        resetCaseSubTypes: () => dispatch(resetCaseSubTypes()),
        resetCaseForm: () => dispatch(resetCaseForm()),
        getCourts: (countyId: number) => dispatch(getCourts(countyId)),
        resetCourts: () => dispatch(resetCourts()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseForm);
